function changeVideo() {
    let isSafari = navigator.vendor.match(/apple/i) && !navigator.userAgent.match(/crios/i) && !navigator.userAgent.match(/fxios/i) && !navigator.userAgent.match(/Opera|OPT\//);
    const video = document.querySelector('.transparent-video');

    if (isSafari) {
        video.setAttribute('src', '/assets/video/label-mac.mov');
    } else {
        video.setAttribute('src', '/assets/video/2_2.webm');
    }
    video.addEventListener('canplay', () =>{
        setTimeout(() => {
            gsap.to('.preloader', {autoAlpha: 0, duration: 1, ease: 'ease', onComplete: () => document.body.classList.remove('lock')})

            console.log('canplay')
        }, 500)
    })
    console.log('change video')
}

export default changeVideo;